module.exports = __webpack_public_path__ + "static/media/ic_text.71757c20.svg";